import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { NbDialogService } from '@nebular/theme';
import { ObjectEditModalComponent } from '../edit-object/object-edit-modal.component';
import { ObjectChangesModalComponent } from '../object-changes/object-changes-modal.component'
import { ConfirmModalComponent } from '../modals/confirm-modal.component';

import { MissionService, GameService, TemplateService, ObjectService, LanguageService } from '../../_services/index';
import { GameObject } from '../../classes';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-edit-objects-param',
    templateUrl: './edit-objects.component.html',
    styleUrls: ['./edit-objects.component.scss'],
    standalone: false
})

export class EditObjectsComponent {

  objectTypes = [];
  objects = [];
  objectSubscriber;
  
  couponsObjects = [];
  objectsObjects = [];
  indicesObjects = [];
  temoinsObjects = [];
  gameId;
  game;
  templateId;
  template;

  url;
  objectsBytype;
  //typeLabelSelected = "";
  typeIdSelected = "";

  constructor(private route: ActivatedRoute,
    public objectService: ObjectService,
    public gameService: GameService,
    public missionService: MissionService,
    public templateService: TemplateService,
    private dialogService: NbDialogService,
    public languageService: LanguageService) {
      this.route
      .params
      .subscribe(params => {
        // Récupération des valeurs de l'URL
        console.log('params:'+JSON.stringify(params));
        this.gameId = params['id'];
        this.templateId = params['templateId'];
        console.log('Load data - gameId:'+this.gameId+', templateId:'+this.templateId);
        
        if(this.objectSubscriber){
          this.objectSubscriber.unsubscribe();
        }
        if(this.gameId){
          this.gameService.getGame(this.gameId)
          .subscribe(game => {
            if(game){
              this.game = game;
            }
          });
          this.objectSubscriber = this.objectService.listObjects(`games/${this.gameId}/objects`)
          .subscribe(objects => {;
            if(objects){
              this.objects = this.sort(objects);
            }
          });
        }
        else if(this.templateId){
          this.templateService.getTemplate(this.templateId)
          .subscribe(template => {
            if(template){
              this.template = template;
            }
          });
          this.objectSubscriber = this.objectService.listObjects(`game_templates/${this.templateId}/objects`)
          .subscribe(objects => {
            if(objects){
              this.objects = this.sort(objects);
            }
          });
        }
        /*let previousUrl
        this.router.events.pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          console.log('prev:', event.url);
          previousUrl = event.url;
          this.url = previousUrl.split("/")
        });*/
      });   
      
      this.objectService.listObjectTypes()
      .subscribe(objectTypes => {
        this.objectTypes = objectTypes;
        for (let i = 0; i < this.objectTypes.length; i++) {
          this.getTypes()
          if(i===0) {
            this.objectTypes[i].active = true
            this.typeIdSelected = this.objectTypes[i].id
          } else this.objectTypes[i].active = false
        }

        if(!this.containsOrder(this.objects)) {
          this.setOrder(this.objects)
          this.saveOrder(this.objects)
        }
          this.objects = this.sort(this.objects)
      });
  }

  typeObjects = []
  getTypes(){
    for(let i = 0; i < this.objectTypes.length; i++){
      this.typeObjects[this.objectTypes[i].id] = this.objects.filter(obj => this.objectTypes[i].id == obj.objectTypeId)
    }
  }

  setOrder(objects){
    let typeObjects = []
    for(let i = 0; i < this.objectTypes.length; i++){
      typeObjects = objects.filter(obj => this.objectTypes[i].id == obj.objectTypeId)
      for (let j = 0; j < typeObjects.length; j++) {
        let index = objects.findIndex(object => object.id == typeObjects[j].id)
        if(index>=0){
          this.objects[index].orderNum = j+1;
        }
      }
    }
  }
  containsOrder(objects) {
    let exist = true
    for (let i = 0; i < objects.length; i++) {
      if (!objects[i]?.orderNum) {
        exist = false;
      }
    }
    return exist;
  }

  sort(objects){
    return objects.sort((x, y) => x.orderNum - y.orderNum);
  }
  changePosition(old_order, new_order, object){
    let old_index = this.objects.findIndex(obj => obj.objectTypeId == object.objectTypeId && old_order == obj.orderNum);
    let new_index = this.objects.findIndex(obj => obj.objectTypeId == object.objectTypeId && new_order == obj.orderNum);
    console.log('old_index:'+old_index);
    console.log('new_index:'+new_index);
    console.log('this.objects[new_index]:'+this.objects[new_index]);
    if(this.objects[new_index]){
      this.objects[old_index].orderNum = new_order
      this.objects[new_index].orderNum = old_order
      
      this.saveOrderObject(this.objects[old_index])
      this.saveOrderObject(this.objects[new_index])
      //this.objects = this.sort(this.objects)
    }
  }

  saveOrder(objects){
    for (const object of objects) {
      this.saveOrderObject(object)
    }
  }
  async saveOrderObject(object){
    await this.objectService.setObject(object).then(value => {
    }, err => {
      console.log('err :', err)
    });
  }
  changeTab(id){
    //this.typeLabelSelected =  id.tabTitle
    this.typeIdSelected =  id.tabId;
  }
  games
  applyChanges(){
    let objectType = this.objectTypes.filter(obj => obj.id == this.typeIdSelected)
    this.objectService.listObjectsByObjectTypes(`game_templates/${this.templateId}/objects`, objectType[0].id)
    .pipe(take(1))
    .subscribe(objectsBytype => {
      this.gameService.listTemplateGames(this.template.id)
      .pipe(take(1))
      .subscribe(async games => {
        this.games = games
        for (let i = 0; i < games.length; i++) {
          const element = games[i];
          await this.objectService.listObjectsByObjectTypes(`games/${games[i].id}/objects`, objectType[0].id)
          .pipe(take(1))
          .subscribe(objects => {
             this.games[i].objects = objects
          })
        } 
        this.dialogService.open(ObjectChangesModalComponent, { 
          context: {
            data : {
              currentLang:this.languageService.currentLang,
              games: this.games,
              objectTypeId: objectType[0].id,
              templateId:this.templateId,
              templateObjects:objectsBytype
            }
          }, closeOnBackdropClick: false
        })
        .onClose.subscribe(async res => {
          console.log('Dialog returns:'+res);
          if(res){
          }
        });
      })
    })
  }

  ngOnInit() {
  }

  /** loadTemplateData(templateUid){
    this.templateService.getTemplate(templateUid)
    .pipe(take(1))
    .subscribe(template => {
      if(template){
        this.template = template;
        this.missionService.listMissions(`game_templates/${templateUid}/missions`)
        .pipe(take(1))
        .subscribe(async missions => {
          if(missions){
            template.missions = missions;
            await this.compareWithTemplate();
          }
        });
      }
    });
  }
  
  async compareWithTemplate(){
    if(this.template && this.template.missions && this.game && this.game.missions){
      console.log('execute compareWithTemplate');
      await this.missionService.listGameModifsFromTemplate(this.template.missions, [this.game], null, this.game.workingLanguages);
    }
  }*/

  getObjectCount(typeId){
    if(this.objects){
      return this.objects.filter(function( obj ) {return obj.objectTypeId == typeId}).length;
    }
    return 0;
  }

  editObject(object, type){
    if(this.gameId){
      if(!object){
        object = new GameObject(`games/${this.game.id}/objects`);
        object.gameId = this.gameId;
        object.objectTypeId = type.id;
        object.orderNum = this.objects.filter(function( obj ) {return obj.objectTypeId == type.id}).length+1;
      }
      this.dialogService.open(ObjectEditModalComponent, { 
        context: {
          model: object,
          type: this.objectTypes.filter(type => type.id == object.objectTypeId)[0],
          game: this.game,
          languages: this.game.workingLanguages
        }, closeOnBackdropClick: false
      })
      .onClose.subscribe(res => {
        console.log('Dialog returns:'+res);
      });
    } else {
      if(!object){
        object = new GameObject(`game_templates/${this.templateId}/objects`);
        object.templateId = this.templateId;
        object.objectTypeId = type.id;
      }
      this.dialogService.open(ObjectEditModalComponent, { 
        context: {
          model: object,
          game: this.game,
          languages: this.template.workingLanguages
        }, closeOnBackdropClick: false
      })
      .onClose.subscribe(res => {
        console.log('Dialog returns:'+res);
      });
    }
  }

  deleteObject(object){
    this.dialogService.open(ConfirmModalComponent, { 
      context: {
        title: 'Confirmation',
        message: `Do you want to delete object '`+object.labels[this.languageService.currentLang]+`'?`
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(async res => {
      console.log('Dialog returns:'+res);
      if(res){
        console.log('Delete mission');
        await this.objectService.deleteObject(object);
      }
    });
  }
}